<template>
  <div class="login-main">
    <!-- <canvas
      v-if="$store.state.adminSetting.adst06 == ''"
      id="canvas"
      class="canvas"
    ></canvas> -->
    <img v-if="$store.state.adminSetting.adst06 == ''" src="../assets/img/登录背景.png" class="canvas" />
    <img v-else :src="$store.state.adminSetting.adst06" class="canvas" />

    <div class="login-bg">
      <div class="register-bj">
        <!-- 左边内容 -->
        <div class="register-left left">
          <el-carousel :interval="10000" indicator-position="outside" height="475px">
            <el-carousel-item v-for="item in inviteList" :key="item">
              <img :src="item" style="width: 100%; height: 100%" />
            </el-carousel-item>
          </el-carousel>
        </div>

        <!-- 右边内容 -->
        <div class="register-right left">
          <div class="register-right-content">
            <h3>
              {{ $store.state.adminSetting.adst03 || "BIM协同管理平台" }}
            </h3>
            <div v-show="loginCss">
              <!-- <div class="register-rigth-img">
                <img
                  src="../assets/img/Group 783.png"
                  alt
                  @click="weChatLogin"
                />
              </div> -->
              <div class="accounts">
                <div class="accounts-icon"></div>
                <el-form :model="numberValidateForm" ref="numberValidateForm" label-width="100px" class="demo-ruleForm"
                  :rules="rules" @submit.native.prevent>
                  <el-form-item prop="userName">
                    <el-input v-model="numberValidateForm.userName" size="medium" :placeholder="$t('login.username')"
                      autocomplete="off"></el-input>
                  </el-form-item>
                </el-form>
              </div>

              <div class="accounts">
                <div class="accounts-icon password-icon"></div>
                <el-form :model="numberValidateForm" ref="numberValidateForm2" label-width="100px" class="demo-ruleForm"
                  :rules="rules" @submit.native.prevent>
                  <el-form-item prop="pwd">
                    <el-input show-password type="password" size="medium" :placeholder="$t('login.password')"
                      v-model="numberValidateForm.pwd" autocomplete="new-password" @keyup.enter.native="
                        mylogin('numberValidateForm', 'numberValidateForm2')
                        "></el-input>
                  </el-form-item>
                </el-form>
              </div>

              <!-- 注册/忘记密码按钮 -->
              <!-- <div class="cl-more">
                <a href="#" @click="register()">注册</a>
                <a href="#" class="wj" @click="forgetpassword()">忘记密码？</a>
              </div> -->

              <el-button type="primary" round @click="mylogin('numberValidateForm', 'numberValidateForm2')">{{
                $t('login.login') }}</el-button>
              <el-button type="primary" style="margin-left: 0;" round @click="switchthelanguage">{{
                lang == 'zh' ? $t('login.Switch_to_English') : $t('login.Switch_to_Chinese') }}</el-button>
            </div>
            <div v-show="weChatloginCss">
              <div class="register-rigth-wecimg">
                <img src="../assets/img/Group 782.png" alt @click="webLogin" />
              </div>

              <div style="border: 1px" id="login_container"></div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="$store.state.adminSetting.ptbaArr" class="record">
        <p>
          <a :href="$store.state.adminSetting.ptbaArr.record1Link" target="_blank">{{
            $store.state.adminSetting.ptbaArr.record1 }}</a>
        </p>
        <p class="mar-top10">
          <a :href="$store.state.adminSetting.ptbaArr.record2Link" target="_blank">{{
            $store.state.adminSetting.ptbaArr.record2 }}</a>
        </p>
      </div>
      <div v-else class="record">
        <p>
          <a href="http://www.beian.gov.cn/" target="_blank">Copyright © 2018 EABIM.CN ALL Rights Reserved.</a>
        </p>
        <p class="mar-top10">
          <a href="http://www.beian.gov.cn/" target="_blank">沪ICP备 16037428号-1</a>
        </p>
      </div>
    </div>

    <!-- 注册弹窗 -->
    <el-dialog :modal-append-to-body="false" title="注册" :visible.sync="dialogVisible" :before-close="handleClose">
      <el-card class="box-card">
        <el-tabs v-model="activeName">
          <!--账号注册选项卡-->
          <el-tab-pane class="card-pane" label="账号注册" name="1" disabled>
            <el-form ref="activeNamedialogForm" :model="activeNamedialogForm" label-width="100px" :rules="rules">
              <el-form-item prop="regiName">
                <el-input v-model="activeNamedialogForm.regiName" placeholder="请输入姓名"></el-input>
              </el-form-item>

              <el-form-item prop="regiSex">
                <el-select v-model="activeNamedialogForm.regiSex" clearable placeholder="请选择性别">
                  <el-option label="男" value="male"></el-option>
                  <el-option label="女" value="female"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="regiIph">
                <el-input v-model="activeNamedialogForm.regiIph" placeholder="请输入手机号"></el-input>
              </el-form-item>

              <el-form-item prop="regiCode">
                <el-input v-model="activeNamedialogForm.regiCode" placeholder="请输入验证码"></el-input>
                <span @click="getReCode()" class="login-code-img">
                  <span :style="reOneStyle">{{ reOne }}</span>
                  <span :style="reTwoStyle">{{ reTwo }}</span>
                  <span :style="reThreeStyle">{{ reThree }}</span>
                  <span :style="reFourStyle">{{ reFour }}</span>
                </span>
              </el-form-item>

              <!-- 按钮 -->
              <el-form-item class="foot-btn">
                <el-button type="primary" @click="submitForm('activeNamedialogForm')">确 认</el-button>
              </el-form-item>
            </el-form>
            <a href="#" @click="backlogin" style="position: relative; float: right">点击此处返回登录</a>
          </el-tab-pane>

          <!--输入动态码选项-->
          <el-tab-pane label="输入动态码" name="2" disabled>
            <div class="pane">
              <i class="el-icon-circle-check"></i>
              <span class="iphsp">手机注册码已发送至：{{ this.temdata.regiIph }}</span>
              <span class="tipssp">注册有效期5分钟，若输入的手机号有误，请更换手机号</span>
            </div>
            <el-input class="pane-input" v-model="activCode" placeholder="请输入6位数验证码"></el-input>
            <!-- 按钮 -->
            <el-row class="pane-row">
              <el-button type="primary" @click="Prestep()">上一步</el-button>
              <el-button class="row-submi" type="primary" @click="open()">确认并提交</el-button>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-dialog>

    <!-- 忘记密码 -->
    <el-dialog :modal-append-to-body="false" title="找回密码" :visible.sync="dialogVisible1" :before-close="forhandleClose">
      <el-card class="box-card">
        <el-tabs v-model="tabName">
          <!-- 找回密码首页 -->
          <el-tab-pane class="card-pane" label="找回密码" name="1" disabled>
            <el-form ref="forgetForm" :model="forgetForm" label-width="100px" :rules="rules">
              <el-form-item prop="forgIph">
                <el-input v-model="forgetForm.forgIph" placeholder="请填写手机号"></el-input>
              </el-form-item>
              <el-form-item prop="forgCode">
                <el-input v-model="forgetForm.forgCode" placeholder="请输入验证码"></el-input>
                <span @click="getReCode()" class="login-code-img">
                  <span :style="reOneStyle">{{ reOne }}</span>
                  <span :style="reTwoStyle">{{ reTwo }}</span>
                  <span :style="reThreeStyle">{{ reThree }}</span>
                  <span :style="reFourStyle">{{ reFour }}</span>
                </span>
              </el-form-item>
              <!-- 按钮 -->
              <el-form-item class="foot-btn">
                <el-button type="primary" @click="forsubmitForm('forgetForm')">确 认</el-button>
              </el-form-item>
            </el-form>
            <a href="#" @click="Forbacklogin" style="position: relative; float: right">点击此处返回登录</a>
          </el-tab-pane>

          <!--验证码选项-->
          <el-tab-pane label="输入验证码" name="2">
            <div class="pane">
              <i class="el-icon-circle-check"></i>
              <span class="iphsp">手机注册码已发送至：{{ this.forgetForm.forgIph }}</span>
              <span class="tipssp">注册有效期5分钟，若输入的手机号有误，请更换手机号</span>
            </div>
            <el-input class="pane-input" v-model="inpCode" placeholder="请输入6位数验证码"></el-input>
            <!-- 按钮 -->
            <el-row class="pane-row">
              <el-button type="primary" @click="Forprestep()">上一步</el-button>
              <el-button class="row-submi" type="primary" @click="forgetCode()">确认并提交</el-button>
            </el-row>
          </el-tab-pane>

          <!--重置密码选项-->
          <el-tab-pane label="重置密码" name="3" disabled>
            <!--找回密码选项卡-->
            <el-form ref="resetForm" :model="resetForm" label-width="100px" :rules="rules">
              <el-form-item prop="newpwd">
                <el-input class="pane-inppwd" v-model="resetForm.newpwd" placeholder="请输入新密码"></el-input>
              </el-form-item>
              <el-form-item prop="conpwd">
                <el-input class="pane-inppwd" v-model="resetForm.conpwd" placeholder="请确认与新密码一致"></el-input>
              </el-form-item>
              <!-- 按钮 -->
              <el-form-item class="foot-btnpwd">
                <el-row class="pane-rowpwd">
                  <el-button class="row-submiup" type="primary" @click="Forprestep()">上一步</el-button>
                  <el-button class="row-submipwd" type="primary" @click="forgetopen('resetForm')">确认并提交</el-button>
                </el-row>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
// import { bgjs } from "../../public/manjs.js";
import { globalMethods } from "@/mixin/langMixin.js";
import {
  login,
  IndexPublicity,
  AddPublicityClicks,
  WeChatLogin,
  shortproving,
  UserRegister,
  Forgetpassword,
  KnyRegister,
} from "@/setAxios.js";
export default {
  name: "login",
  components: {},
  data() {
    var checkPhone = (rule, value, callback) => {
      var reg1 = /^1[3-9]\d{9}$/;
      if (!reg1.test(value)) {
        return callback(new Error("请输入正确的手机格式"));
      } else {
        callback();
      }
    };
    return {
      bannerWidth: "",
      loginType: "success",
      loginType1: "",
      isLogin: false,
      loginCss: true,
      weChatloginCss: false,
      weChatLoginView: false,
      dialogVisible: false, //账号注册弹窗关闭
      activeName: "1", //账号注册标签页，第一张
      activCode: "", //验证页的输入框
      activeNamedialogForm: {
        regiName: "", //注册人姓名
        regiSex: "男", //注册人性别
        regiIph: "", //注册人手机号
        regiCode: "", //注册人验证码
      },
      //保存验证页输入的值
      temdata: "",

      dialogVisible1: false, //忘记密码弹窗关闭
      tabName: "1", //忘记密码标签页，第一张
      inpCode: "", //验证页的输入框

      forgetForm: {
        forgIph: "", //找回密码手机号
        forgCode: "", //验证码
      },
      temsdata: "",

      resetForm: {
        newpwd: "", //重置新密码
        conpwd: "", //新密码一致
      },

      //显示的验证码部分,以及随机样式部分
      reOne: "1",
      reTwo: "7",
      reThree: "4",
      reFour: "2",
      reOneStyle: "",
      reTwoStyle: "",
      reThreeStyle: "",
      reFourStyle: "",
      //全局用来获取验证码的值字段
      flushReCode: "",

      numberValidateForm: {
        userName: "",
        pwd: "",
      },

      //文本框验证是否为空
      rules: {
        userName: [
          { required: true, message: this.$t('login.username'), trigger: "blur" },
        ],
        pwd: [{ required: true, message: this.$t('login.password'), trigger: "blur" }],
        regiName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        regiIph: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        regiCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        forgIph: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        forgCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        newpwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 8, message: "长度8位以上", trigger: "blur" },
        ],
        conpwd: [
          { required: true, message: "请输入一致密码", trigger: "blur" },
        ],
      },
      inviteList: [
        require("@/assets/img/Frame.png"),
        // "../img/login/banner-login-2.png",
        // "../img/login/banner-login-3.png",
        // "../img/login/banner-login.png",
      ],
      url: "",
      lang: localStorage.getItem("lang") || "zh", // 语言
    };
  },
  mounted() {
    // if (this.$store.state.adminSetting.adst06 == "") {
    //   bgjs();
    // }
  },
  created() {
    // const loading = this.$loading({
    //   lock: true,
    //   text: "初始化中，请稍等...",
    //   spinner: "el-icon-loading",
    //   background: "rgba(248,248,255,1)",
    // });
    IndexPublicity().then((res) => {
      // loading.close();
      if (res.Data.length > 0) {
        this.inviteList = [];
        res.Data.forEach((v) => {
          this.inviteList.push(this.$store.state.baseUrl + v.publ06);
        });
      }
    });
    this.url = this.$store.state.baseUrl;
    var code = window.location.search;
    if (code.indexOf("code") > 0) {
      code = window.location.search.substr(1).split("=")[1].split("&")[0];
      let params = {
        code,
      };
      WeChatLogin(params).then((res) => {
        if (res.Code == 0) {
          this.$message({
            type: "danger",
            message: res.Message,
          });
          setTimeout(() => {
            window.location.href = location.origin + "/#/";
          }, 2000);
        } else {
          localStorage.setItem("url", this.$store.state.baseUrl);
          localStorage.setItem("isAdmin", false);
          localStorage.setItem("token", res.Data.token);
          localStorage.setItem("isLogin", true);
          localStorage.setItem("id", res.Data.uid);
          this.$store.state.uid = res.Data.uid;
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
            text: "登录成功...",
          });
          setTimeout(() => {
            loading.close();
            window.location.href = location.origin + "/#/";
          }, 2000);
        }
      });
    } else if (code.indexOf("from") > 0) {
      let from = window.location.search.substr(1).split("=")[1].split("&")[0];
      code = window.location.search.substr(1).split("=")[1].split("&")[1];
      if (from == "kny") {
        let params = {
          code,
        };
        KnyRegister(params).then((res) => {
          if (res.Code == 0) {
            this.$message({
              type: "danger",
              message: res.Message,
            });
            setTimeout(() => {
              window.location.href = location.origin + "/#/";
            }, 2000);
          } else {
            localStorage.setItem("url", this.$store.state.baseUrl);
            localStorage.setItem("isAdmin", false);
            localStorage.setItem("token", res.Data.token);
            localStorage.setItem("isLogin", true);
            localStorage.setItem("id", res.Data.uid);
            this.$store.state.uid = res.Data.uid;
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
              text: "登录成功...",
            });
            setTimeout(() => {
              loading.close();
              window.location.href = location.origin + "/#/";
            }, 2000);
          }
        });
      }
    }
  },
  mixins: [globalMethods],
  methods: {
    switchthelanguage() {
      this.Language(this.lang);
    },
    webLogin() {
      this.loginCss = true;
      this.weChatloginCss = false;
      this.loginType = "success";
      this.loginType1 = "";
    },
    weChatLogin() {
      this.loginCss = false;
      this.weChatloginCss = true;
      this.loginType1 = "success";
      this.loginType = "";
      new WxLogin({
        id: "login_container",
        appid: "wxa983fcfd0157af0e",
        scope: "snsapi_login",
        state: Base64.encode(new Date().getDay()),
        redirect_uri: location.origin + "/#/",
      });
    },
    AddHot(id) {
      AddPublicityClicks({ id: id }).then((res) => { });
    },
    mylogin(formName, formName2) {
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$refs[formName2].validate((valid) => {
            if (valid) {
              let params = {
                login: _this.numberValidateForm.userName,
                pwd: _this.numberValidateForm.pwd,
              };

              login(params).then((res) => {
                localStorage.clear();
                localStorage.setItem("url", this.$store.state.baseUrl);
                if (res.Code === 1) {
                  if (res.Data.Role === 1) {
                    this.$store.state.firstlogin = res.Data.firstlogin;
                    localStorage.setItem("url", this.$store.state.baseUrl);
                    localStorage.setItem("isAdmin", true);
                    this.$message({
                      showClose: true,
                      message: "恭喜你，登录成功",
                      duration: 1000,
                      type: "success",
                      onClose: function () {
                        localStorage.setItem("token", res.Data.token);
                        _this.$store.commit("updateToken", res.Data.token);
                        localStorage.setItem("isLogin", true);
                        localStorage.setItem("id", res.Data.uid);
                        _this.$store.state.uid = res.Data.uid;
                        _this.$router.replace({
                          path: "/admin",
                        });
                      },
                    });
                  } else if (res.Data.Role == 0) {
                    localStorage.setItem("isAdmin", false);
                    localStorage.setItem("url", this.$store.state.baseUrl);
                    localStorage.setItem("token", res.Data.token);
                    localStorage.setItem("isLogin", true);
                    localStorage.setItem("id", res.Data.uid);
                    this.$store.state.uid = res.Data.uid;
                    this.$router.replace({
                      path: "/enterpriseIndex",
                    });
                  }
                } else {
                  this.$message.error(res.Message);
                  // $("#captcha").empty();
                  // jigsaw.init(document.getElementById("captcha"));
                }
                _this.numberValidateForm.userName = "";
                _this.numberValidateForm.pwd = "";
              });
            }
          });
        }
      });
    },

    //打开注册弹窗
    register() {
      this.dialogVisible = true;
      this.activeName = "1";
      this.getReCode();
    },
    //注册上一步按钮
    Prestep() {
      this.activeName = Number(this.activeName) - 1 + "";
    },
    //注册确认按钮
    submitForm(activeNamedialogForm) {
      this.$refs[activeNamedialogForm].validate(async (v) => {
        if (v) {
          if (this.activeNamedialogForm.regiCode != this.flushReCode) {
            this.$message.error("验证码有误！");
            return;
          } else {
            //保存注册页输入内容
            this.temdata = this.activeNamedialogForm;
            //拿到手机号发送短信验证
            let IphNumber = this.temdata.regiIph;
            let res = await shortproving({ phonenumber: IphNumber });
            if (res.Code == 1) {
              this.$message.success(res.Message);
              //切换Tab标签页面
              this.activeName = Number(this.activeName) + 1 + "";
            } else if (res.Code == 0) {
              this.$message.error(res.Message);
              return;
            }
          }
        }
      });
    },
    //注册确认并提交按钮
    async open() {
      if (this.activCode == "") {
        this.$message({
          message: "请输入验证码",
          type: "warning",
        });
      } else {
        let params = {
          name: this.temdata.regiName,
          sex: this.temdata.regiSex,
          phonenumber: this.temdata.regiIph,
          smscode: this.activCode,
        };
        let res = await UserRegister(params);

        if (res.Code == 1) {
          this.dialogVisible = false;
          this.$confirm(res.Message, "注册成功", {
            confirmButtonText: "返回登录",
            iconClass: "el-icon-success",
          }).then(() => {
            //注册表单清空
            this.activeNamedialogForm = {
              regiName: "", //注册人姓名
              regiSex: "", //注册人性别
              regiIph: "", //注册人手机号
              regiCode: "", //注册人验证码
            };
            this.activCode = ""; //注册验证码页清空
          });
        } else {
          this.$message.error(res.Message);
        }
      }
    },
    //关闭注册弹窗
    handleClose(done) {
      this.$confirm("确认关闭吗？")
        .then((_) => {
          done(); //关闭注册弹窗
          //注册表单清空
          this.activeNamedialogForm = {
            regiName: "", //注册人姓名
            regiSex: "", //注册人性别
            regiIph: "", //注册人手机号
            regiCode: "", //注册人验证码
          };
          this.activCode = ""; //注册验证码页清空
        })
        .catch((_) => { });
    },
    //注册返回登录页面
    backlogin() {
      //关闭注册弹窗
      this.dialogVisible = false;
      //注册表单清空
      this.activeNamedialogForm = {
        regiName: "", //注册人姓名
        regiSex: "", //注册人性别
        regiIph: "", //注册人手机号
        regiCode: "", //注册人验证码
      };
      this.activCode = ""; //注册验证码页清空
    },

    //打开忘记密码弹窗
    forgetpassword() {
      this.dialogVisible1 = true;
      this.tabName = "1";
      this.getReCode();
    },
    //关闭忘记密码弹窗
    forhandleClose(done) {
      this.$confirm("确认关闭吗？")
        .then((_) => {
          done();
          //忘记密码表单清空
          this.forgetForm = {
            forgIph: "", //找回密码手机号
            forgCode: "", //验证码
          };
          this.inpCode = ""; //忘记密码验证码页清空
          //忘记密码重置页面清空
          this.resetForm = {
            newpwd: "", //重置新密码
            conpwd: "", //新密码一致
          };
        })
        .catch((_) => { });
    },
    //忘记密码返回登录按钮
    Forbacklogin() {
      //关闭忘记密码弹窗
      this.dialogVisible1 = false;
      //忘记密码表单清空
      this.forgetForm = {
        forgIph: "", //找回密码手机号
        forgCode: "", //验证码
      };
      this.inpCode = ""; //忘记密码验证码页清空
      //忘记密码重置页面清空
      this.resetForm = {
        newpwd: "", //重置新密码
        conpwd: "", //新密码一致
      };
    },
    //忘记密码上一步按钮
    Forprestep() {
      this.tabName = Number(this.tabName) - 1 + "";
    },
    //忘记密码的确认按钮
    forsubmitForm(forgetForm) {
      this.$refs[forgetForm].validate(async (v) => {
        if (v) {
          if (this.forgetForm.forgCode != this.flushReCode) {
            this.$message.error("验证码有误！");
            return;
          } else {
            let MiphNumber = this.forgetForm.forgIph;
            let res = await shortproving({ phonenumber: MiphNumber });
            if (res.Code == 1) {
              this.$message.success(res.Message);
              //切换Tab标签页面
              this.tabName = Number(this.tabName) + 1 + "";
            } else if (res.Code == 0) {
              this.$message.error(res.Message);
              return;
            }
          }
        }
      });
    },
    //忘记密码的验证页确认密码
    forgetCode() {
      if (this.inpCode == "") {
        this.$message({
          message: "请输入验证码",
          type: "warning",
        });
      } else {
        this.tabName = Number(this.tabName) + 1 + "";
      }
    },
    //忘记密码的重置密码确认按钮
    forgetopen(resetForm) {
      this.$refs[resetForm].validate(async (v) => {
        if (v) {
          if (this.resetForm.conpwd != this.resetForm.newpwd) {
            this.$message.error("与新密码不一致，请重新输入！");
            return;
          } else {
            let params = {
              phonenumber: this.forgetForm.forgIph,
              smscode: this.inpCode,
              pwd: this.resetForm.conpwd,
            };
            let res = await Forgetpassword(params);
            if (res.Code == 1) {
              this.$confirm(res.Message, "重置成功", {
                confirmButtonText: "返回登录",
                iconClass: "el-icon-success",
              }).then(() => {
                this.dialogVisible1 = false;
                //忘记密码表单清空
                this.forgetForm = {
                  forgIph: "", //找回密码手机号
                  forgCode: "", //验证码
                };
                this.inpCode = ""; //忘记密码验证码页清空
                //忘记密码重置页面清空
                this.resetForm = {
                  newpwd: "", //重置新密码
                  conpwd: "", //新密码一致
                };
              });
            } else {
              this.$message.error(res.Message);
            }
          }
        }
      });
    },

    //生成验证码(需要把获取验证码的方法放到页面载入事件里面，保证进入页面可以刷到验证码)
    getReCode() {
      let chars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
      let res = "";
      for (let i = 0; i < 4; i++) {
        let id = Math.ceil(Math.random() * 9);
        res += chars[id];
      }
      this.reOne = res[0];
      this.reTwo = res[1];
      this.reThree = res[2];
      this.reFour = res[3];
      //这里直接调用获取样式，保证验证码生成之后，可以直接获取验证码的样式
      this.getStyle();
      this.flushReCode = res; //全局用来获取验证码的值字段
      return res.toString();
    },
    //随机验证码样式
    getStyle() {
      let chars = [
        "font-weight: bold;font-size: 32px;text-decoration:overline;color:#BA55D3;font-family: 'Arabic Typesetting'",
        "font-weight: bold;font-size: 26px;text-decoration:overline;color:pink;font-family: 'PingFang SC'",
        "font-weight: solid;font-size: 33px;text-decoration:line-through;color:hotpink;font-family: Vijaya",
        "font-weight: bold;font-size: 25px;text-decoration:underline;color:#9400D3; font-family: Aharoni",
        "font-weight: bold;font-size: 29px;text-decoration:underline;color:#FF8C00;font-family: 'Arabic Typesetting'",
        "font-weight: bold;font-size: 27px;text-decoration:line-through;color:#FF1493;font-family: 'PingFang SC'",
        "font-weight: solid;font-size: 28px;text-decoration:line-through;color:#1E90FF;font-family: Vijaya",
      ];
      let res = [];
      for (let i = 0; i < 4; i++) {
        let id = Math.ceil(Math.random() * 7);
        res[i] += chars[id - 1];
      }
      this.reOneStyle = res[0];
      this.reTwoStyle = res[1];
      this.reThreeStyle = res[2];
      this.reFourStyle = res[3];
      return res.toString();
    },
  },
};
</script>
<style>
body {
  min-width: 1080px;
  min-height: 700px;
  overflow: auto;
}

#app {
  min-width: 100%;
  min-height: 100%;
  overflow: auto;
}
</style>
<style lang="less" scoped>
.container {
  width: 350px;
  margin: 0 auto 20px;
}

#msg {
  width: 100%;
  line-height: 40px;
  font-size: 14px;
  text-align: center;
}

a:link,
a:visited,
a:hover,
a:active {
  margin-left: 100px;
  color: #0366d6;
}

.left {
  float: left;
}

.login-bg {
  position: relative;
  top: 145px;

  .icon-bg {
    position: absolute;
    top: 0;
    left: -3%;
  }

  .icon-bg-2 {
    position: absolute;
    top: 36%;
    right: 0;
  }
}

.canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.register-right-content h3 {
  position: relative;
  color: #5b78fa;
  text-align: center;
  font-size: 22px;
  font-weight: revert;
  top: 30px;
}

.register-text {
  width: 100%;
  letter-spacing: 10px;
  text-align: center;
  font-size: 34px;
  font-family: Adobe Heiti Std;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  line-height: 29px;
  text-shadow: 0px 1px 3px rgba(0, 0, 0, 0.18);
  position: relative;
  margin-top: 9%;
}

.register-bj {
  width: 900px;
  height: 475px;
  background: #fff;
  -webkit-box-shadow: 0 0 4px 0 hsla(0, 0%, 50.2%, 0.17);
  box-shadow: 0 0 4px 0 hsla(0, 0%, 50.2%, 0.17);
  border-radius: 5px;
  position: relative;
  margin: 0 auto;
  margin-top: 2%;

  .register-left {
    width: 55%;
    height: 100%;
    background-color: #409eff;
    border-radius: 5px 0 0 5px;
    position: relative;
    overflow: hidden;

    .aa {
      position: relative;
      height: 100%;
      display: flex;
      justify-content: center;
      align-content: center;

      .register-left-content {
        position: relative;
        width: 475px;
        height: 100%;
        margin: 0;
      }

      img {
        display: block;
        height: 100%;
        width: 100%;
      }
    }
  }

  .register-right {
    width: 45%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .register-right-content {
      width: 65%;
      height: 70%;

      button {
        margin-top: 20px;
        width: 100%;
      }

      p {
        font-size: 20px;
        font-weight: 700;
        color: #000000;
      }

      .accounts {
        margin: 30px 0 46px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 20px;

        input {
          border: none;
          outline: none;
          width: 100%;
          margin-left: 20px;
        }

        &::before {
          content: "";
          position: absolute;
          bottom: -6px;
          width: 100%;
          height: 2px;
          background-color: #cccccc;
        }

        .accounts-icon {
          margin-left: 10px;
          width: 20px;
          height: 30px;
          background: url("../assets/img/Vector.png") no-repeat 100%;
          background-size: 100%;
        }

        .password-icon {
          width: 20px;
          height: 30px;
          background: url("../assets/img/Vector-1.png") no-repeat 100%;
          background-size: 100%;
        }
      }
    }
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  /deep/ .el-input__inner {
    background-color: rgba(0, 0, 0, 0);
    // border: none;
    width: 300px;
    position: absolute;
    left: -90px;
    top: -20px;
    border: none;
  }

  /deep/ .el-form-item__error {
    position: absolute;
    left: -75px;
    top: 48px;
  }

  /deep/ .el-form,
  .demo-ruleForm {
    width: 100%;
    height: 40px;
  }

  /deep/ .el-form-item__content {
    margin: 0;
  }
}

/deep/ .el-input__suffix {
  top: -20px !important;
}

/deep/ a {
  cursor: pointer;
}

.record {
  position: relative;
  text-align: center;
  font-size: 12px;
  margin-top: 8%;

  a {
    color: #666;
  }
}

//新添加
.el-button.is-round {
  border-radius: 5px;
  padding: 12px 23px;
}

.el-button {
  box-shadow: darkgrey 0px -1px 6px 0px;
}

.cl-more>a {
  position: relative;
  float: left;
  margin-left: 5px;
}

.cl-more .wj {
  position: revert;
  float: right;
}

.register-rigth-img {
  position: relative;
  margin-top: -60px;

  img {
    position: relative;
    margin-left: 255px;
    width: 78px;
    cursor: pointer;
  }
}

.register-rigth-wecimg {
  position: relative;
  margin-top: -57px;

  img {
    position: relative;
    margin-left: 270px;
    cursor: pointer;
    width: 60px;
  }
}

.card-pane {
  .el-input {
    width: 80%;
    margin-top: 10px;
  }

  .el-select {
    width: 80%;
  }

  .foot-btn {
    position: relative;
    margin-left: 160px;
    margin-top: 10px;

    .el-button {
      width: 150px;
    }
  }
}

.pane-row {
  display: flex;
  justify-content: center;
  margin-top: 20px;

  .row-submi {
    position: relative;
    margin-left: 40px;
  }
}

.pane-rowpwd {
  .row-submiup {
    position: relative;
    margin-left: 60px;
  }

  .row-submipwd {
    position: relative;
    margin-left: 40px;
  }
}

.pane {
  position: relative;
  margin-top: 20px;

  .el-icon-circle-check:before {
    position: relative;
    margin-left: 90px;
    color: #409eff;
    font-size: 35px;
  }

  .iphsp {
    position: fixed;
    font-weight: bolder;
    padding-left: 7px;
  }

  .tipssp {
    position: relative;
    padding-left: 7px;
    top: 10px;
    font-size: 13px;
    color: #a6a6a6;
  }
}

.pane-input {
  position: relative;
  margin-left: 95px;
  margin-top: 35px;
  width: 65%;
}

.pane-inpagain {
  position: relative;
  margin-left: 95px;
  width: 65%;
  margin-top: 15px;
}

.pane-inppwd {
  position: relative;
  width: 80%;
  margin-top: 15px;
}

.el-icon-success:before {
  color: #409eff;
}

//随机数图片样式
.login-code-img {
  background-image: url(data:image/jpg;base64,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);
  border: 1px solid #f0f0f0;
  color: #333;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 5px;
  line-height: 38px;
  text-indent: 5px;
  text-align: center;
  width: 33%;
  position: relative;
  margin-left: -95px;
}

// 新增
.dis-bok {
  display: block;
}

.width100 {
  width: 100px !important;
}

.mar-r10 {
  margin-right: 10px !important;
}

#captcha {
  position: relative !important;
}

#login_container {
  position: relative;
  height: 400px;
  margin-top: 20px;
  margin-left: -12px;
}

.mar-top10 {
  margin-top: 10px;
}
</style>